import React from 'react'
import { SvgIcon } from '@material-ui/core'

const CertificateIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="25" height="21.833" viewBox="0 0 25 21.833">
      <g id="Group_5849" data-name="Group 5849" transform="translate(5254.5 -13516.833)" fill="none" stroke="#fff">
        <path id="Path_13707" data-name="Path 13707" className="cls-1" d="M1377 609.666h6a7.539 7.539 0 0 1 1.78.1 3.011 3.011 0 0 1 2.12 2.121 7.676 7.676 0 0 1 .1 1.776v-15.33c0-2.828 0-4.243-.88-5.121s-2.29-.879-5.12-.879h-4c-.94 0-1.41 0-1.71.293s-.29.764-.29 1.707v13.333c0 .943 0 1.415.29 1.707s.77.293 1.71.293z" transform="translate(-6629 12925)" />
        <path id="Path_13708" data-name="Path 13708" className="cls-1" d="M1397 609.666h-6a7.539 7.539 0 0 0-1.78.1 3.011 3.011 0 0 0-2.12 2.121 7.676 7.676 0 0 0-.1 1.776v-15.33c0-2.828 0-4.243.88-5.121s2.29-.879 5.12-.879h4c.94 0 1.41 0 1.71.293s.29.764.29 1.707v13.333c0 .943 0 1.415-.29 1.707s-.77.293-1.71.293z" transform="translate(-6629 12925)" />
      </g>
    </SvgIcon>
  )
}

export default CertificateIcon
